var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "vuesax/outline/document-copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M9.099 18.25a1.6 1.6 0 01-1.143-.474l-3.471-3.471a1.616 1.616 0 012.286-2.286l2.328 2.331 8.129-8.131a1.617 1.617 0 012.288 2.286l-9.274 9.271a1.6 1.6 0 01-1.143.474z",
    fill: "currentColor"
  })));
}
export default SvgVuesaxOutlineCheck;